<template>
  <v-card 
    class="ma-2 card-rounded" 
    flat>
    <v-card-text class="py-0">
      <div class="loading-holder" v-if="fetchingLogs">
        <v-progress-circular 
          indeterminate
          color="primary"
        />
      </div>
      <apexchart
        v-if="!fetchingLogs"
        type="line"
        height="200"
        width="100%"
        :options="chartOptions"
        :series="chartData()"
      />
    </v-card-text>
    
  </v-card>
</template>

<script>
import apexchart from 'vue-apexcharts'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    apexchart
  },
  props: {
    logs: { type: Array },
    logtypes: { type: Array },
    datePeriod: { type: Number },
    fetchingLogs: { type: Boolean }
  },
  computed: {
    lastYear() {
      const currentDate = moment().format('MM/YYYY')
      const dates = []
      dates.push(currentDate)
      for (let i = 1; i < this.datePeriod; i++) {
        const date = moment().subtract(i, 'months').format('MM/YYYY')
        dates.push(date)
      }
      return dates.reverse()
    },
    chartOptions() {
      let options = {
        chart: {
          height: 200,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: [...this.lastYear],
        }
      }
      return options
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  methods: {
    ...mapGetters([
      'user'
    ]),
    userStartDate() {
      const start = this.user().residencyStart
      const months = moment.duration(moment(new Date()).diff(start)).asMonths()
      return Math.round(months)
    },
    chartData() {
      let dateCount = [...this.lastYear]
      dateCount = dateCount.map(date => date = { id: date, count: 0 })

      let logbooks = JSON.parse(JSON.stringify(this.logtypes))
      let dataset = []

      logbooks.forEach(logbook => {
        delete logbook.components
        logbook.dateCount = JSON.parse(JSON.stringify(dateCount))
        this.logs.forEach(log => {
          logbook.dateCount.map(date => {
            if(date.id === moment(log.createdAt).format('MM/YYYY') && log.logbook === logbook.id) {
              date.count++
            }
          })
        })
        dataset.push({
          name: logbook.name,
          data: logbook.dateCount.map(date => date = date.count)
        })
      })

      const data = dateCount.map(date => date = date.count )
      return dataset
    },
  }
}
</script>

<style>
.loading-holder {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 100%;
}
</style>
